import {
	BulkDeleteButton,
	Create,
	Edit,
	List,
	SimpleForm,
	TextInput,
	BooleanInput,
	Datagrid,
	TextField,
	EditButton,
	required,
	ReferenceInput,
	AutocompleteInput,
	ReferenceField,
	SelectInput
} from 'react-admin';
import { default as icon } from '@mui/icons-material/History';
import { modulePromptChoices } from '../promptKeys';

const list = () =>
	<List>
		<Datagrid rowClick="edit" bulkActionButtons={<BulkDeleteButton mutationMode="pessimistic" />}>
			<ReferenceField source="module_id" reference="modules" />
			<TextField source="prompt_key" />
			<TextField source="label" />
			<TextField source="active" />
			<EditButton />
		</Datagrid>
	</List>;

const FormFields = (
	<SimpleForm warnWhenUnsavedChanges>
		<ReferenceInput source="module_id" reference="modules">
			<AutocompleteInput validate={required()} optionText="title" />
		</ReferenceInput>
		<SelectInput source="prompt_key" choices={modulePromptChoices} validate={required()} />
		<TextInput source="label" />
		<BooleanInput source="active" />
		<TextInput source="body" multiline fullWidth validate={required()} />
	</SimpleForm>
);

const edit = () => <Edit redirect="edit">{FormFields}</Edit>;
const create = () => <Create>{FormFields}</Create>;

export const PromptVersion = { list, edit, create, icon };

export default PromptVersion;
